import { Box } from "@mui/system";
import NavBar from "./NavBar";

const AppLayout = ({ children }) => {
  return (
    <>
      <Box>
        <NavBar />
      </Box>
      <Box sx={{ pt: "60px" }}>{children}</Box>
    </>
  );
};

export default AppLayout;
